/**
 * Created by asiulik on 15.05.2017.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', './finderConst', '../../utils'], function ($, _, EventEmitter, FinderConst, Utils) {

    var contentHeightAnimationFactor = .8;
    var closeButtonSelector = '.finder__content__close';
    var contentItemAbsoluteClass = 'finder__content__item--static';

    function FinderContent($finderContainer) {

        this.$finderContent = $finderContainer.find(FinderConst.finderContentSelector);
        this.$finderContentItems = this.$finderContent.find(FinderConst.finderContentItem);

        this.$closeContentButton = this.$finderContent.find(closeButtonSelector);
        this.bindEvents();

    }

    FinderContent.prototype = _.clone(EventEmitter.prototype);

    FinderContent.prototype.bindEvents = function(){

        var _this = this;

    };

    FinderContent.prototype.showContent = function (contentId) {

        var _this = this;
        var animationDefer = Utils.createPromise();

        this.displayContentId = contentId;

        var contentElement = _this.getContentById(_this.displayContentId);

        _this.$finderContentItems.removeClass('finder__marker--active');
        contentElement.addClass('finder__marker--active');

        var scrollValue = Math.abs(contentElement.position().top);

        if(scrollValue > 2000) {
            var mockDiff = contentElement.position().top < 0 ? 500 : -500;
            var mockScrollValue = contentElement.offset().top - this.$finderContent.offset().top + this.$finderContent.scrollTop() + mockDiff;
            this.$finderContent.scrollTop(mockScrollValue);
            Utils.scrollPositionAnimate(contentElement.offset().top - this.$finderContent.offset().top + this.$finderContent.scrollTop(), 400, this.$finderContent);
        } else {
            Utils.scrollPositionAnimate(contentElement.offset().top - this.$finderContent.offset().top + this.$finderContent.scrollTop(), 400, this.$finderContent);
        }

        // var lastElementHeight = _this.contentElement ? _this.contentElement.height() : 0;
        //
        // if (_this.contentElement) {
        //     _this.contentElement.addClass('animate--down');
        // }
        //
        // var contentElement = _this.getContentById(_this.displayContentId);
        // _this.contentElement = contentElement;
        //
        // _this.$finderContentItems.removeClass(FinderConst.finderContentItemActiveClass);
        //
        // Utils.heightAnimation(_this.$finderContent, contentElement.height(),
        //     animationDurationStrategy(contentElement.height(), lastElementHeight), function () {
        //         _this.$finderContentItems.removeClass('content--static animate--down');
        //
        //         contentElement.addClass('content--static');
        //         _this.$finderContent.css('height', 'auto');
        //
        //         contentElement.addClass(FinderConst.finderContentItemActiveClass);
        //
        //         if (!_this.$finderContent.hasClass('finder__content--display')) {
        //             _this.$finderContent.addClass('finder__content--display')
        //         }
        //
        //         animationDefer.resolve();
        //
        //     });

        animationDefer.resolve();

        return animationDefer.promise();
    };

    function animationDurationStrategy(currentElementHeight, newElementHeight) {
        return Math.abs(currentElementHeight - newElementHeight) * contentHeightAnimationFactor;
    }

    FinderContent.prototype.hideContent = function () {

        var _this = this;
        var animationDefer = Utils.createPromise();

        _this.$finderContentItems.removeClass('finder__marker--active');

        animationDefer.resolve();
        return animationDefer.promise();

    };

    FinderContent.prototype.getContentById = function (id) {
        return this.$finderContentItems.filter(function (index, item) {
            return $(item).attr('id') == id
        })
    };

    FinderContent.prototype.getVisibleContent = function () {
        return this.getContentById(this.displayContentId);
    };

    return FinderContent;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/finder/finderContent.js